import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
Vue.use(Vuex);

const state = {
  promiseBtn: ["video", "add"],
  nav: [],
  isdark: true,
  isFullScreen: false,
  carMsg: {
    carNo: "",
    deviceNo:"",
    startTime: "",
    endTime: "",
    play: 1
  },
  personMsg: {},
  control: false,
  menu: {
    //菜单状态
    status: false //false--展开 true--缩进
  },
  topMenuList: [{ name: "数据看板", link: "/control", now: 0, id: 0 }],
  nowActiveTitle: "",
  csr: {},
  dots: { 调度中心: 12 },
  bendi: {
    name: "智慧派车平台",
    extend: "2222222",
    mainLogoPic: "static/logo/b.png",
    linkLogoPic: "static/logo/defaul.png",
    loginBgPic: "static/login/ly.jpg",
    footerEnabled: true,
    footerLink: "",
    footerTitle: "",
    linkTitle: "555555",
    mainTitle: "",
    remark: "7777777",
    bgColor: "#f5f5f5",
    themeName: "black",
    fontColor: "#fff",
    themeColor: "#333",
    aidColor: "#0bbf11",
    adornColor: "#388ded",
    otherColor: "#e9f1f7",
    company: "",
    qrCodeList: [
      {
        qrCodePic: "static/e/webapp.png",
        qrCodeTitle: "安卓app",
        qrCodeDes: "浏览器扫码"
      }
    ]
  },
  inCss(data) {
    /*  var rootcss = document.getElementById("rootcss");
     rootcss.innerHTML =
       ":root {--loginColor:" +
       data.adornColor +
       ";}" */
  },
  IsLeaderApply: true, //是否领导审批,

  signDetail: {}
};

const mutations = {
  SET_LEADER_APPLY(state, data) {
    state.IsLeaderApply = data;
  },
  SET_SIGN_DETAIL(state, data) {
    state.signDetail = data;
  },
  changeIndex(state, data) {
    // state.signDetail = data;
  },
};

var tmplId = getUrlKey("t");
if (tmplId == null) {
  state.csr = state.bendi;
  state.inCss(state.csr);
  document.getElementById("webTitle").innerHTML = state.csr.name;
  document.getElementById("webPhoto").href = "static/logo/ly1.png";
} else {
  setTimeout(() => {
    gettmpl();
  }, 200);
}

function gettmpl() {
  let params = {
    id: tmplId
  };
  axios({
    method: "post",
    url: "/tmpl/item",
    data: params
  }).then(res => {
    console.log(res);
    state.csr = res.data.data;
    state.inCss(res.data.data);
    document.getElementById("webTitle").innerHTML = state.csr.name;
    document.getElementById("webPhoto").href = state.csr.smallLogo
      ? state.csr.smallLogo
      : "static/logo/defaul.png";
  });
}
function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}
export default new Vuex.Store({
  state,
  mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js